import useMediaQuery from '../../hooks/useMediaQuery'
import Calculator from '../Calculator'
import styles from './Investments.module.scss'
// import Title from "../Title";
import { Swiper, SwiperSlide } from 'swiper/react'
import { InvestmentsProps } from './Investments.types'
// import { useTranslation } from "react-i18next";
import { Suspense, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { InView } from 'react-intersection-observer'
import Container from '../SAIRUS_NEW/Container/Container'
import IconsList from '../SAIRUS_NEW/IconsList/IconsList'
import SectionTitle from '../SAIRUS_NEW/SectionTitle/SectionTitle'
import { IColor } from '../UI/ColoredInfoBlock/ColoredInfoBlock.types'

interface IIconItem {
	iconName: string
	iconColor: IColor
	textColor: IColor
	text: string
}

export default function Investments(props: InvestmentsProps) {
	const { t } = useTranslation()

	const [show, setShow] = useState(false)

	const onShow = (inView: boolean, entry: IntersectionObserverEntry) => {
		if (!show && inView) {
			setShow(true)
		}
	}

	const iconsItems: IIconItem[] = [
		{
			iconName: 'growing-up-finger',
			iconColor: 'magenta',
			textColor: 'magenta',
			text: t('landing.investments.l1'),
		},
		{
			iconName: 'money',
			iconColor: 'blue',
			textColor: 'blue',
			text: t('landing.investments.l2'),
		},
		{
			iconName: 'clock-money',
			iconColor: 'purple',
			textColor: 'purple',
			text: t('landing.investments.l3'),
		},
	]

	const matches2 = useMediaQuery('(min-width: 750px)')

	return (
		<Suspense>
			<InView onChange={onShow} className={styles.wrapper} id='partners'>
				{show && (
					<Container>
						<div className={styles.body}>
							<div className={styles.a}>
								<SectionTitle
									text={t('landing.investments.title')}
									gradientText='Sairus'
									className={styles.title}
								/>
								<div className={styles.quote}>
									<p>{t('landing.investments.p1')}</p>
									<div className={styles.plugArea}>
										<span className={styles.plug}></span>
										<span className={styles.plug}></span>
									</div>
								</div>
							</div>
							<div className={styles.b}>
								<p>{t('landing.investments.p2')}</p>
								<IconsList
									iconsItems={iconsItems}
									smallGap={true}
									align='center'
									isSlider={false}
								/>
								<p className='p3 gray'>{t('landing.investments.p3')}</p>
								<div className={styles.quote}>
									<p>{t('landing.investments.p1')}</p>
									<div className={styles.plugArea}>
										<span className={styles.plug}></span>
										<span className={styles.plug}></span>
									</div>
								</div>
							</div>
							{matches2 ? (
								<>
									<div className={styles.c}>
										<Calculator
											rate={0.8}
											min={50}
											max={1499}
											color='magenta'
											type='MEGA'
										/>
									</div>
									<div className={styles.d}>
										<Calculator
											rate={0.9}
											min={1500}
											max={5999}
											color='purple'
											type='GIGA'
										/>
									</div>
									<div className={styles.f}>
										<Calculator
											rate={1.0}
											min={6000}
											max={50000}
											color='cian'
											type='TERA'
										/>
									</div>
								</>
							) : (
								<Swiper slidesPerView={1.2} spaceBetween={10} grabCursor={true}>
									<SwiperSlide className={styles.slide}>
										<Calculator
											rate={0.8}
											min={50}
											max={1499}
											color='magenta'
											type='MEGA'
										/>
									</SwiperSlide>
									<SwiperSlide className={styles.slide}>
										<Calculator
											rate={0.9}
											min={1500}
											max={5999}
											color='purple'
											type='GIGA'
										/>
									</SwiperSlide>
									<SwiperSlide className={styles.slide}>
										<Calculator
											rate={1.0}
											min={6000}
											max={50000}
											color='cian'
											type='TERA'
										/>
									</SwiperSlide>
								</Swiper>
							)}
						</div>
					</Container>
				)}
			</InView>
		</Suspense>
	)
}
